import {PageDoc} from "./PageDoc";

export class Category {
  id: number = 0;
  name: string = "";
  label: string = "";
  priority:number=0;
  parent: Category | undefined ;
  pageDocs: Array<PageDoc> = new Array<PageDoc>();
}
